import React from 'react';
import { connect } from 'react-redux';
import './TimeEntryInfoBullet.css';
import { ASSETS_FOLDER } from '../../../../../../../../constants';

const TimeEntryInfoBullet = props => {
  const { data, hiliteId } = props;

  const styleMain = {
    opacity: hiliteId.length === 0 || data.hiliteId === hiliteId ? 1 : 0.2,
  };
  const styleIco = {
    backgroundColor: data.color,
  };
  return (
    <div className="info-entry-bullet" style={styleMain}>
      <div className="ico" style={styleIco}>
        <img
          src={`${ASSETS_FOLDER}img/ico/bullet-map-${data.ico}.png`}
          alt=""
        />
      </div>
      <div className="label">{data.label}</div>
    </div>
  );
};

const mapStateToProps = state => ({
  hiliteId: state.app.hiliteId,
});

export default connect(mapStateToProps)(TimeEntryInfoBullet);



// WEBPACK FOOTER //
// ./src/components/App/Dukla/Scene/SceneUI/TimeEntryInfo/TimeEntryInfoContent/TimeEntryInfoBullet/TimeEntryInfoBullet.js